import React, { useState } from 'react';

import FilterListIcon from '@mui/icons-material/FilterList';
import {
    Box,
    Card,
    Collapse,
    Grid,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    Tooltip,
    UiDialog as Dialog,
} from '@sunwisesoftware/sunwise-ui';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
    AutocompleteField,
    InputSearch,
    ManageCsvDropdown,
} from 'common/components';

import { getRateOptions, getCompanyOptions } from '../helpers';

import DateFilterForm from './DateFilterForm';

const BulkOperationsCard = ({
    companies,
    downloadFile,
    filterData,
    handleOnChangeSearch,
    handleOnSelectCompany,
    handleOnSelectRate,
    isFetching,
    rates,
}) => {
    const { t } = useTranslation();
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [filterIsOpen, setFilterIsOpen] = React.useState(false);

    const toggleFilter = () => setFilterIsOpen((prev) => !prev);

    return (
        <Card sx={{ mb: '16px !important' }}>
            <Card.Body>
                <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                    <InputSearch
                        id="input-search"
                        onChange={handleOnChangeSearch}
                        placeholder={t('Search')}
                        value={filterData?.searchText}
                    />

                    <Tooltip title={t('Filter', { count: 2 })}>
                        <IconButton onClick={toggleFilter}>
                            <FilterListIcon />
                        </IconButton>
                    </Tooltip>

                    <ManageCsvDropdown
                        handleDownload={() => setIsOpenModal(true)}
                    />
                </Box>
                <Collapse in={filterIsOpen}>
                    <Grid
                        alignItems="end"
                        container
                        justifyContent="end"
                        mt={2}
                    >
                        <Grid size={{ lg: 14, md: 14, xs: 18 }}>
                            <AutocompleteField
                                disabled={isFetching}
                                label={
                                    isEmpty(filterData?.company)
                                        ? t('All the companies')
                                        : t('Company')
                                }
                                onChange={handleOnSelectCompany}
                                options={getCompanyOptions(companies)}
                                value={filterData?.company}
                            />
                        </Grid>
                        <Grid size={{ lg: 4, md: 4, xs: 18 }}>
                            <FormControl fullWidth size="small">
                                <InputLabel>{t('Rate')}</InputLabel>
                                <Select
                                    label={t('Rate')}
                                    onChange={(e) =>
                                        handleOnSelectRate(e.target)
                                    }
                                    value={filterData.rateName}
                                    variant="outlined"
                                >
                                    {getRateOptions(rates).map(
                                        ({ label, value, disabled }) => (
                                            <MenuItem
                                                disabled={disabled}
                                                key={`rate-${value}-${label}`}
                                                value={value}
                                            >
                                                {label}
                                            </MenuItem>
                                        ),
                                    )}
                                </Select>
                            </FormControl>
                        </Grid>
                        {/* <Grid
                        size={{ lg: 3, md: 5, xs: 18 }}
                        sx={{ order: { xs: 5, md: 4 } }}
                    >
                        <StatusFilterSelect
                            filterBy={filterData?.status}
                            handleSelected={handleOnSelectStatus}
                            variant="outlined"
                        />
                    </Grid> */}
                    </Grid>
                </Collapse>

                <Dialog
                    onClose={() => setIsOpenModal(false)}
                    open={isOpenModal}
                    size="sm"
                    title={t('Download CSV')}
                >
                    <DateFilterForm
                        onSubmit={({ date }) => {
                            const dateParts = date.split('/');
                            downloadFile({
                                ...filterData,
                                month: dateParts[0],
                                year: dateParts[1],
                            });
                            setIsOpenModal(false);
                        }}
                    />
                </Dialog>
            </Card.Body>
        </Card>
    );
};

BulkOperationsCard.propTypes = {
    companies: PropTypes.array,
    downloadFile: PropTypes.func,
    filterData: PropTypes.object,
    handleOnChangeSearch: PropTypes.func,
    handleOnSelectCompany: PropTypes.func,
    handleOnSelectRate: PropTypes.func,
    isFetching: PropTypes.bool,
    rates: PropTypes.array,
};

export default BulkOperationsCard;
